import product1 from "../images/business/product-1.png";
import product2 from "../images/business/product-2.png";
import product3 from "../images/business/product-3.png";
import product4 from "../images/business/product-4.png";
import product5 from "../images/business/product-5.png";
import product6 from "../images/business/product-6.jpeg";
// import productLimsDetail from "../images/business/product-lims-detail.png";
// import productY from "../images/business/product-y.png"
// import productYDetail from "../images/business/product-y-detail.png"
// import productLims from "../images/business/product-lims.png";

export const productList = [{
  imgSrc: product1,
  // detailImgSrc: product1,
  title: '法医实验室STR数据分析系统（简称FastSTR）',
  desc: '"FastSTR"是完全具有自主知识产权的国产自主研发的法医物证学STR数据分析软件，主要应用于人类身份鉴定和犯罪调查等领域，可作为GeneMapper® ID 和 GeneMapper® IDX人类身份数据分析软件的替代品。'
},
{
  imgSrc: product2,
  // detailImgSrc: product2,
  title: '二代测序分析平台（HiH Forensic NGS Analysis Platform）',
  desc: '海华法医二代测序分析平台是一款专为法医遗传学研究和实践设计的高效、精准、灵活的法医遗传学分析工具。旨在为法医遗传学研究者和从业人员提供一站式的数据分析解决方案。'
},
{
  imgSrc: product3,
  // detailImgSrc: product3,
  title: '内外网数据摆渡机器人',
  desc: '内外网数据摆渡机器人主要应用于物理隔离的网络间数据交换而开发出的数据导入/导出系统，使用光盘介质为载体。集数据自动摆渡、用户管理、审批、病毒查杀、日志管理等功能于一体，利用智能机械臂，实现光盘在光驱、盘仓间的自动流转，最终实现将数据从一个网络传递到另一个网络的传输。'
},
{
  imgSrc: product4,
  // detailImgSrc: product4,
  title: '服务器密码机',
  desc: '服务器密码机可以独立为应用系统提供高性能的数据加解密服务，也可作为身份认证系统、密钥管理系统等主要密码设备和核心构件。'
},
{
  imgSrc: product5,
  // detailImgSrc: product5,
  title: '血卡点卡机',
  desc: '血卡点卡机通过自动识别技术将样本上的条形码信息与现有采集平台进行数据互通，结合工业自动化的手段，从多层面实现样本查重，提高查重的效率，减少工作量，从而准确甄别需要检验的样本，减少建库费用的同时缩短建库时间。'
},
{
  imgSrc: product6,
  // detailImgSrc: productLimsDetail,
  title: '实验室专家辅助分析与管理系统',
  desc: '实验室专家辅助分析与管理系统（LIMS）依靠实验室内部网络和实验室信息数据库将实验室中的遗传分析仪、实验室自动化平等仪器设备连接起来，为各类样品采集、送检和受理提供工作平台，也是实验室的软件工程做平台，既能满足日常检验、数据分析和技术管理要求，又能保证数据库建设的严格管理、控制。'
}
];
